export default __webpack_public_path__ + "static/media/company_name_and_naics.b2da2150.csv";